import { SVGProps } from 'react';

function ExportIcon(props: SVGProps<SVGSVGElement>) {
  const { style } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      style={{ ...style, rotate: '-180deg' }}
    >
      <g id="Group_21043" data-name="Group 21043" transform="translate(-0.345)">
        <g id="Component_435" data-name="Component 435">
          <rect
            id="Rectangle_8169"
            data-name="Rectangle 8169"
            width="40"
            height="40"
            rx="15"
            transform="translate(0.345)"
            fill="#fff"
          />
        </g>
        <g id="export-svgrepo-com" transform="translate(5.733 5.659)">
          <path
            id="Path_14893"
            data-name="Path 14893"
            d="M8.906,9.1a.96.96,0,0,0,1.357,0l2.2-2.2V17.38a.96.96,0,0,0,1.919,0V6.9l2.2,2.2A.96.96,0,0,0,17.94,7.745L14.1,3.906a.96.96,0,0,0-1.357,0L8.906,7.745A.96.96,0,0,0,8.906,9.1Z"
            transform="translate(1.188)"
            fill="#7281a4"
            fillRule="evenodd"
          />
          <path
            id="Path_14894"
            data-name="Path 14894"
            d="M14.611,22.611A10.236,10.236,0,0,0,24.847,12.375h-4.8c-1.206,0-1.809,0-2.184.375s-.375.978-.375,2.184a2.879,2.879,0,1,1-5.758,0c0-1.206,0-1.809-.375-2.184s-.978-.375-2.184-.375h-4.8A10.236,10.236,0,0,0,14.611,22.611Z"
            transform="translate(0 2.446)"
            fill="#7281a4"
          />
        </g>
      </g>
    </svg>
  );
}

export default ExportIcon;
